import video from './video.mp4';
import image from './image.png';

export default { video, image };
